interface CookieOptions {
  path?: string;
  maxAge?: number;
  secure?: boolean;
  domain?: string;
  sameSite?: 'Strict' | 'Lax' | 'None';
}
export const setCookie = (name: string, value: string, options: CookieOptions) => {
  const { maxAge, path = '/', domain, secure = true, sameSite = 'None' } = options;

  let cookieString = `${name}=${encodeURIComponent(value)}`;

  if (path) cookieString += `; path=${path}`;
  if (domain) cookieString += `; domain=${domain}`;
  if (maxAge) cookieString += `; max-age=${maxAge}`;
  if (secure) cookieString += '; secure';
  if (sameSite) cookieString += `; SameSite=${sameSite}`;

  try {
    document.cookie = cookieString;
  } catch (error) {
    console.warn('Cannot set cookie:', error);
  }
};

export const getCookie = (name: string): string | null => {
  const cookies = document.cookie.split(';').reduce(
    (acc, cookie) => {
      const [name, value] = cookie.trim().split('=');
      if (name && value) {
        acc[name.trim()] = decodeURIComponent(value.trim());
      }
      return acc;
    },
    {} as Record<string, string>,
  );

  return cookies[name] || null;
};
